const ENPerspective = {
	"Agora selecione outro objetivo": "Now select another objective",
	"Adicionar Perspectiva": "Add Perspective",
	"Alterar Perspectiva": "Change Perspective",
	"Causa/Efeito excluída com sucesso": "Cause/Effect deleted successfully",
	"Causa/Efeito adicionado com sucesso": "Cause/Effect added successfully",
	"Causa/Efeito cancelado": "Cause/Effect canceled",
	"Descrição da perspectiva": "Description of perspective",
	"Deseja realmente excluir a perspectiva": "Do you really want to delete the perspective",
	"Deseja realmente excluir a Causa/Efeito?": "Do you really want to delete the Cause/Effect?",
	"Editar Perspectiva": "Change Perspective",
	"Erro ao excluir Causa/Efeito": "Error deleting Cause/Effect",
	"Erro ao adicionar perspectiva": "Error adding perspective",
	"Erro ao alterar perspectiva": "Error updating perspective",
	"Erro ao excluir perspectiva": "Error deleting perspective",
	"Erro ao adicionar a Causa/Efeito": "Error adding Cause/Effect",
	"Excluir Perspectiva": "Delete Perspective",
	"Exclusão de Causa/Efeito": "Deleting the Cause/Effect",
	"Exclusão da Perspectiva": "Deleting the Perspective",
	"Excluir Relação": "Delete Relationship",
	"Perspectiva adicionada com sucesso": "Perspective successfully added",
	"Perspectiva alterado com sucesso": "Perspective successfully changed",
	"Perspectiva excluída com sucesso": "Perspective successfully deleted",
	"Selecione outro objetivo": "Select another objective",
	"Mapa": "Map",
	"Mover Perspectiva": "Move Perspective",
	"Não é possivel mover perspectiva que possui Causa/Efeito": "Cannot move perspective that has Cause/Effect",
	"Não é possivel mover objetivo que possui Causa/Efeito": "Cannot move objective that has Cause/Effect",
	"Não é possível criar um relacionamento Causa x Efeito para uma perspectiva de ordem inferior": "Cannot create a Cause x Effect relationship for a lower-order perspective",
	"Nova Perspectiva": "New Perspective"
};

export default ENPerspective;
